<template>
    <div>

        <h4 class="mb-10 pl-4 text-lg">
            <span class="pb-2 border-b-4 border-blue">{{ label }}</span>
        </h4>
        <div v-if="optional" class="px-4 pb-8">Leave all fields empty if not applicable.</div>

        <div class="flex">
            <div class="flex-1 px-4 pb-2">
                <form-group :name="name + '.address'" label="Address" :required="true">
                    <input type="text" class="input" v-model="address.address">
                </form-group>
            </div>
        </div>

        <div class="flex flex-col sm:flex-row">
            <div class="flex-1 px-4 pb-0 sm:pb-4">
                <form-group :name="name + '.post_code'" label="Post Code" :required="true">
                    <input type="text" class="input" v-model="address.post_code">
                </form-group>
            </div>

            <div class="flex-1 px-4 pb-0 sm:pb-4">
                <form-group :name="name + '.city'" label="City" :required="true">
                    <input type="text" class="input" v-model="address.city">
                </form-group>
            </div>

            <div class="flex-1 px-4 pb-0 sm:pb-4">
                <form-group :name="name + '.province'" label="State/Province">
                    <input type="text" class="input" v-model="address.province">
                </form-group>
            </div>
        </div>

        <div class="flex">
            <div class="flex-1 px-4 pb-0 sm:pb-4">
                <form-group :name="name + '.country'" label="Country" :required="true">
                    <v-select label="name" :options="countries" v-model="address.country"
                              placeholder="Type to find country..."></v-select>
                </form-group>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    props: ['value', 'label', 'name', 'optional'],

    computed: {
        ...mapState(['countries'])
    },

    data() {
        return {
            address: null
        }
    },

    created() {
        let address = this.value
        if (!address || Array.isArray(address)) {
            address = {
                address: null,
                post_code: null,
                province: null,
                country: null
            }
        }
        this.address = address
    },

    watch: {
        'address': {
            deep: true,
            handler(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>
